<template>
    <div>
        <h3 class="page-title">教师</h3>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/homework/course' }">{{$route.query.name}}</el-breadcrumb-item>
            <el-breadcrumb-item>教师</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="toolbar">
          <el-select
            size="small"
            v-model="teacher_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入教师姓名"
            :remote-method="getTeacherList"
            :loading="teacherLoading">
            <el-option
              v-for="item in teacherList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-button type="success" size="small" @click="addTeacher">添加教师</el-button>
        </div>
        <div>
            <el-table v-loading="loading" empty-text="无数据" :data="dataList" stripe style="width: 100%">
                <el-table-column prop="name" label="姓名" width="160"></el-table-column>
                <el-table-column prop="cellphone" label="联系电话"></el-table-column>
                <el-table-column prop="email" label="电子邮箱"></el-table-column>
                <el-table-column prop="skype" label="Skype"></el-table-column>
                <el-table-column prop="created_at" label="创建时间" width="230" align="center">
                    <template slot-scope="scope">
                        {{scope.row.created_at | dateFormat}}
                    </template>
                </el-table-column>
                <el-table-column prop="admin" label="权限" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.admin" @click="setNoAdmin(scope.row)" size="mini" type="primarys">管理员</el-button>
                        <el-button v-if="!scope.row.admin && isAdmin" size="mini" type="text" @click="setAdmin(scope.row)">设为管理员</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="courses_count" label="班级数量" align="center">
                  <template slot-scope="scope">
                      <router-link :to="{path: '/homework/course', query: { teacher_id: scope.row.id} }">{{scope.row.courses_count}}</router-link>
                  </template>
                </el-table-column>
                <el-table-column v-if="isAdmin" prop="status" label="账号状态" align="center" width="80">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-value="enable"
                            inactive-value="disable"
                            @change="handleStatusSwitch(scope.row, $event)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" v-if="isAdmin || teacher_id == user_profile.id">
                    <template slot-scope="scope">
                        <el-button
                            type="danger"
                            size="mini"
                            plain
                            @click="remove(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      total: 0,
      loading: true,
      teacher_id: this.$route.query.teacher_id,
      id: this.$route.params.id,
      teacherLoading: true,
      dataList: [],
      teacherList: []
    }
  },

  created () {
    this.getDataList()
    this.getTeacherList()
  },
  computed: {
    ...mapGetters(['isAdmin', 'user_profile'])
  },
  methods: {
    handleStatusSwitch (target, new_state) {
      let type = 'warning'
      let action = '禁用'
      let id = target.id

      let isEnable = new_state

      if (isEnable === 'enable') {
        type = 'success'
        action = '启用'
      }

      this.$confirm(`你确认${action}[${target.name}]?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: type
      }).then(() => {
        if (isEnable) {
          this.$api.users.enable(id).then(data => {
            target.status = true
            this.$message({
              type: 'success',
              message: action + '成功!'
            })
          }).catch(err => {
            target.status = false
            this.$error(err)
          })
        } else {
          this.$api.users.disable(id).then(data => {
            target.status = false
            this.$message({
              type: 'success',
              message: action + '成功!'
            })
          }).catch(err => {
            target.status = true
            this.$error(err)
          })
        }
      }).catch(() => {
        target.status = !isEnable
      })
    },
    addTeacher () {
      if (!this.teacher_id) return
      this.$api.courses.add_teacher(this.id, this.teacher_id).then(data => {
        this.$message({
          type: 'success',
          message: `添加教师成功!`
        })
        this.teacher_id = ''
        this.getDataList()
      }).catch(err => {
        console.log(err)
      })
    },
    getTeacherList (name) {
      this.teacherLoading = true
      var params = Object.assign({}, { fields: ['id', 'name'], status: 'enable', page: 1, per_page: 100, name })
      this.$api.teachers.list(params).then(data => {
        this.teacherList = data.data
        this.teacherLoading = false
      }).catch(err => {
        console.log(err)
        this.teacherLoading = false
      })
    },
    getDataList () {
      this.loading = true
      this.$api.courses
        .teachers(this.id)
        .then(data => {
          this.dataList = data
          this.loading = false
        })
        .catch(err => {
          this.$error(err)
          this.loading = false
        })
    },
    remove (target) {
      this.$confirm(`你确认删除教师 [${target.name}]?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$api.courses
            .delete_teacher(this.id, target.id)
            .then(data => {
              this.$message({
                type: 'success',
                message: `${target.name} 已从这个班级删除!`
              })
              this.getDataList()
            })
            .catch(err => {
              this.$error(err)
            })
        })
        .catch(() => {})
    },
    search () {
      this.getDataList()
    },
    setAdmin (target) {
      this.$confirm(`你确认设置[${target.name}]为管理员?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        this.$api.users.set_admin(target.id).then(data => {
          target.admin = true
          this.$message({
            type: 'success',
            message: '设置成功!'
          })
        }).catch(err => {
          this.$error(err)
        })
      }).catch(() => {

      })
    },
    setNoAdmin (target) {
      this.$confirm(`你确认取消[${target.name}]的管理员权限吗?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        this.$api.users.set_admin(target.id).then(data => {
          target.admin = false
          this.$message({
            type: 'success',
            message: '设置成功!'
          })
        }).catch(err => {
          this.$error(err)
        })
      }).catch(() => {

      })
    },
  }
}
</script>
